import React from 'react'
import PropTypes from 'prop-types'
// import HealthCard from 'react-health-card'
import logo from '../../../resources/images/logoKenetto-01.svg'

// import './style.css'
// import PanelWithContent from '../../common/PanelWithContent/PanelWithContent'
import PatientBox from '../Home/PatientBox'

export default class DoctorProfile extends React.Component {
  render () {
    return <div className='container-fluid'>
      <div className='col-xs-12 col-md-5 col-lg-4'>
        <div className='card-box'>
          <PatientBox patient={{ photo: logo, name: this.props.doctorObject.name }} />
          {/* <HealthCard */}
          {/* cardNumber='12345678' */}
          {/* name={this.props.doctorObject.name} */}
          {/* focused='name' */}
          {/* showIssueNumber={false} */}
          {/* logoUri={logo} */}
          {/* logoStyle={'opacity: 0.8; right: 10%; top: 10%'} */}
          {/* /> */}
        </div>
      </div>
      {/* col-md-7 col-lg-8 */}
      {/* <div className='col-xs-12'> */}
      {/* <PanelWithContent dataKey={'doctorProfile'} saveData={this.handleSubmit} title={'staticFields.doctorProfile.otherData'} fields={this.props.configuration.elements} /> */}
      {/* </div> */}
    </div>
  }
}

DoctorProfile.propTypes = {
  configuration: PropTypes.object.isRequired,
  doctorObject: PropTypes.shape({name: PropTypes.string.isRequired, picture: PropTypes.string}).isRequired,
  auth: PropTypes.object.isRequired,
  patientChangeHandle: PropTypes.func.isRequired
}
//
// const DoctorIdentification = ({photo, name, email}) => {
//   return <div>
//     <div className='col-xs-12'>
//       <div className='center'><img className='doctorPhoto' src={photo} alt='' /></div>
//     </div>
//     <div className='col-xs-12'>{`Nome - ${name}`}</div>
//     <div className='col-xs-12'>{`Nome - ${email}`}</div>
//   </div>
// }



// WEBPACK FOOTER //
// ./src/components/general/DoctorProfile/DoctorProfile.js